import './App.css';
import Nav from './components/Nav/Nav';
import Footer from './components/Footer/Footer';
function App() {
  return (
    <>
      <Nav />
      <div className='header-section'>
        <div className='container'>
          <div className='header-banner text-center'>
            <h1 className='hero-heading'>At REIS, we REVOLUTIONIZE Real Estate and Real World Asset Governance by leveraging Blockchain and AI.</h1>
            <h4 className="heading-4">The Enabler of next revolution of Tokenization</h4>
            {/* <a href='/' className='btn btn-default btn-green'>Learn More</a> */}
          </div>
        </div>

      </div>
      <div className='section mission'>
        <div className='container'>
          <h2 className='head2-39 '>Real Estate Integrated Solutions Limited (“REIS”) </h2>
          <p className='smalltext'> At REIS, we REVOLUTIONIZE Real Estate Governance by leveraging Blockchain and AI</p>
          <div className='missionbox'>
            <h2 className='head2-39 boxed-mission'><img alt=""src='/img/mission.png' /> Mission</h2>
            <p>
              We are poised to providing straight through blockchain-powered solutions for real estate that eliminate inefficiencies, reduce fraud, and streamline processes. By partnering with government agencies and leveraging blockchain protocols, our mission is to drive digital transformation while offering these services to government users thereby making a strong case for blockchain protocol adoption in public services.</p>
          </div>

        </div>
      </div>
      <div className='why-reis'>
        <div className='container'>
          <div className='whyus'>
            <div className='why-content'>
              <h2 className='head2-39 '> Why REIS?</h2>
              <p>We deliver the simplest and most secure way to work with digital assets in the real estate sector.</p>
              <ul className='redbullet-list'>
                <li>We address the next growth of THE segments</li>
                <li>More than 25 years in the real estate industry</li>
                <li>More than 10 years in the Web3 space</li>
                <li>Expert in the tokenization sector from security token </li>
                <li>to real world asset tokenization</li>
                <li>Revolutionize the sector through transparent and scalable fashion</li>
              </ul>
               {/* <a href='/' className='btn btn-default btn-green learn-more' >Learn more</a> */} 
            </div>
            <div className='whyreisimg'>
              <img alt=""src='/img/whyreis.png' className='img-fluid' />
            </div>
          </div>
        </div>
      </div>
      <div className='section reis-team'>
        <div className='container'>
          <div className='ourteam'>
            <h2 className='head2-46black text-center'>The reis team</h2>
            <div className='reisteam-Card'>
              <div className="card teamcard" >
                <img class="card-img-top" src="/img/mohammed.png" alt="Mohammed Mahfoudh" className='img-fluid' />
                <div class="card-body">
                  <h4 class="card-title">Mohammed Mahfoudh</h4>
                  <p class="card-text">Founder</p>
                  <div className='social-links'>
                    <img src='/img/linkedin.png' width={34} height={31} alt='twitter' />
                    <img src='/img/twitter.png' width={30} height={21} alt='twitter' />
                  </div>
                </div>
              </div>
              <div className="card teamcard" >
                <img class="card-img-top" src="/img/mengchan.png" alt="mengchan" className='img-fluid' />
                <div class="card-body">
                  <h4 class="card-title">Meng-Chan Shu</h4>
                  <p class="card-text">CEO</p>
                  <div className='social-links'>
                    <img src='/img/linkedin.png' width={34} height={31} alt='twitter' />
                    <img src='/img/twitter.png' width={30} height={21} alt='twitter' />
                  </div>
                </div>
              </div>
              <div className="card teamcard" >
                <img class="card-img-top" src="/img/paultarud.png" alt="paultarud" className='img-fluid' />
                <div class="card-body">
                  <h4 class="card-title">Jean-Paul Tarud-Kuborn</h4>
                  <p class="card-text">CSO</p>
                  <div className='social-links'>
                    <img src='/img/linkedin.png' width={34} height={31} alt='twitter' />
                    <img src='/img/twitter.png' width={30} height={21} alt='twitter' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='growing-market'>
        <div className='container'>
          <div className='growingmarketbox'>
            <h2 className=''>A Growing Market Opportunity</h2>
            <p className=''> The global blockchain in real estate market is projected to grow at 48.4% CAGR, reaching $5.8 billion by 2028. REIS is positioned to lead this transformative shift.</p>
              {/* <a href='/' className='btn btn-default btn-green learn-more' >Learn more</a> */} 
          </div>
          <div className='col-lg-6 ms-auto benefits'>
            <h2>Who Benefits from REIS?</h2>
            <p>REIS delivers secure, efficient, and transparent solutions that simplify real estate processes and create new opportunities for all stakeholders.</p>
           <ul className='redbullet-list'>
           <li> Government Agencies</li>
           <li> Citizens</li>
           <li> Developers</li>
           <li> Investors</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
